import { ERROR_CODES } from 'state/error'
import i18n from 'config/i18n'

export const ERROR_MESSAGES: Record<string, Record<string, any>> = {
    title: {
        [ERROR_CODES.INPUT_REQUIRED]: i18n.t('errorMessage.validation.enterRegistrationTitle'),
    },
    description: {
        [ERROR_CODES.INPUT_REQUIRED]: i18n.t('errorMessage.validation.enterRegistrationDescription'),
    },
    approval_expiration_days: {
        [ERROR_CODES.INPUT_REQUIRED]: i18n.t('errorMessage.validation.enterNumberDays'),
    },
    blocksData: {
        [ERROR_CODES.REGISTRATION_DONT_HAVE_BLOCK]: i18n.t(
            'errorMessage.validation.selectRequiredFromPartiposterRegistrationForm',
        ),
        [ERROR_CODES.REGISTRATION_REQUIRES_QUESTION_OR_SUBMISSION_BLOCK]: i18n.t(
            'errorMessage.validation.selectRequiredFromPartiposterRegistrationForm',
        ),
        questionTitle: {
            [ERROR_CODES.INPUT_REQUIRED]: i18n.t('errorMessage.validation.enterQuestionRegistrationForm'),
        },
        title: {
            [ERROR_CODES.INPUT_REQUIRED]: i18n.t('errorMessage.validation.enterFieldTitle'),
        },
        images: {
            [ERROR_CODES.INPUT_REQUIRED]: i18n.t('errorMessage.validation.uploadImageForField'),
        },
        options: {
            [ERROR_CODES.INPUT_REQUIRED]: i18n.t('errorMessage.validation.enterOptionRegistrationForm'),
        },
        data: {
            number_of_photos: {
                [ERROR_CODES.INPUT_REQUIRED]: i18n.t('errorMessage.validation.enterMaximumNumberPhotos'),
            },
            question_number: {
                min: {
                    [ERROR_CODES.INPUT_REQUIRED]: i18n.t('errorMessage.validation.enterMinimumNumberResponse'),
                },
                max: {
                    [ERROR_CODES.INPUT_REQUIRED]: i18n.t('errorMessage.validation.enterMaximumNumberResponse'),
                },
            },
        },
    },
}
